module.exports = __webpack_public_path__ + "static/media/FR-68.89b4104a.geojson";